import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M4 20h16", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m6 16 6-12 6 12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 12h8", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Baseline";
const Baseline = memo(themed(Icon));
export {
  Baseline
};
//# sourceMappingURL=baseline.js.map
